import { computed } from "vue";

import { usePayRangeViewState } from "@/views/PayRanges/composables/usePayRangeViewState";

export function useTableConfig() {
  const viewState = usePayRangeViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Pay range name/location/currency/recurrence",
          sortable: true,
          value: "",
        },
        {
          text: "Pay Range",
          sortable: false,
          value: "",
        },
        {
          text: "Used",
          sortable: false,
          value: "",
        },
        {
          text: "Status",
          sortable: false,
          value: "",
        },
        {
          text: "",
          sortable: false,
          value: "",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
        },
      ],
      columns: [
        {
          field: "",
          component: "PayRangeHeader",
          props: (item) => ({
            class: "my-4",
            ...viewState.getPayRangeHeaderProps(item),
          }),
          events: (item) => ({
            click: () => {
              if (item.status === "draft") {
                viewState.openEditPayRangeModal(item, 1);
              }
            },
          }),
        },
        {
          field: "",
          component: "PayRangeLine",
          props: (item) => ({
            class: "my-4",
            ...viewState.getPayRangeLineProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "used",
          component: null,
          props: () => ({
            class: "my-4",
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "Badge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getUserStatusBadgeProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "PayRangeListButton",
          props: () => ({
            class: "my-4",
          }),
          events: (item) => ({
            click: () => {
              if (item.status === "draft") {
                viewState.openEditPayRangeModal(item, 2);
              }
            },
          }),
        },
        {
          field: "",
          component: "Dropdown",
          props: (item) => ({
            "data-testid": "pay-range-operations-menu",
            "translate-x-offset": 12,
            "translate-y-offset": 30,
            "is-open": false,
            "dropdown-items":
              item.status === "draft"
                ? [
                    { label: "Edit Draft", value: "edit-draft" },
                    { label: "Edit Range Values", value: "edit-values" },
                  ]
                : [],
          }),
          events: (item) => ({
            onClick: async (operation) => {
              if (item.status !== "draft") return;
              if (operation === "edit-draft" || operation?.value === "edit-draft") {
                viewState.openEditPayRangeModal(item, 1);
              }
              if (operation === "edit-values" || operation?.value === "edit-values") {
                viewState.openEditPayRangeModal(item, 2);
              }
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: false,
      hideActiveNo: true,
      activeRecords: {
        field: "",
        value: "  ",
      },
      actionLabel: "Add Pay Range",
      hideGridView: true,
      title: "Pay Ranges",
      showHelpMenu: true,
      getRowStyle: (item) => ({
        backgroundColor: item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
